export default "__VITE_ASSET__5kQ_g6OA__"